import { useCallback, useEffect } from "react";
import "./DownloadButton.css"
import { useGetFileMutation } from "../../store/slices/apiSlice";

export const DownloadButton: React.FC<{ getFormData: () => Record<string, string | number> | undefined; calculatorType: string; disabled: boolean; title: string; wellId?: string }> = ({ getFormData, calculatorType, disabled, title, wellId }) => {
	const [getFile, { data: fileData, isLoading: isDownloadLoading, isSuccess: isDownloadSuccess }] = useGetFileMutation();
	// getFormData is invoked here, at click time, so it always uses the latest
	// input values and never runs (and dispatches validation) during render.
	const onClick = useCallback(async () => {
		const formData = getFormData();
		if (formData)
			await getFile({
				calculator_type: calculatorType,
				excel: '1',
				...formData,
			});

	}, [getFile, getFormData, calculatorType]);

	useEffect(() => {
		if (!fileData) {
			return;
		}

		const url = window.URL.createObjectURL(fileData);
		const link = document.createElement("a");
		link.href = url;
		link.download = `${calculatorType}_results_${wellId ?? "well1"}.xlsx`;

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		window.URL.revokeObjectURL(url);
	}, [fileData]);

	return <button className="download-button shadow" onClick={onClick} disabled={disabled} title={title}>
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
			<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
			<polyline points="7 10 12 15 17 10" />
			<line x1="12" y1="15" x2="12" y2="3" />
		</svg>
	</button>
}